import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { analyzeLevelDuration, analyzeLevelDurationCurrency } from "@/api/dataAll/userSegmentationGrowth";
import { mapState } from 'vuex';
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "userLlayeredClearance",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [// {
      //   label: "新增设备",
      //   id: "device_id"
      // },
      {
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user"
      },
      tableList: [],
      serverList: []
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        character_id: this.paramsData.character_id
      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? analyzeLevelDurationCurrency : analyzeLevelDuration;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var statusArr = []; //处理表头

          for (var i in data) {
            for (var j in data[i]["levels"]) {
              statusArr.push(j);
            }

            break;
          }

          console.log("this.statusArr", statusArr);
          statusArr.forEach(function (item) {
            _this2.tableList.push({
              label: _this2.$t('levelPassCount', {
                level: item
              }),
              prop: "".concat(item, "_pass_count")
            }, {
              label: _this2.$t('levelAvgDuration', {
                level: item
              }),
              prop: "".concat(item, "_avg_duration")
            });
          });
          console.log("this.tableList", _this2.tableList);
          var tableCopyData = data;

          for (var m in tableCopyData) {
            tableCopyData[m]["levelList"] = {};

            for (var _j in tableCopyData[m]["levels"]) {
              tableCopyData[m]["levelList"]["".concat(_j, "_pass_count")] = tableCopyData[m]["levels"][_j]["pass_count"];
              tableCopyData[m]["levelList"]["".concat(_j, "_avg_duration")] = tableCopyData[m]["levels"][_j]["avg_duration"];
            }
          }

          for (var _i in tableCopyData) {
            _this2.tableData.push(_objectSpread(_objectSpread({}, tableCopyData[_i]["levelList"]), {}, {
              level_amount: tableCopyData[_i]["range"]
            }));
          }

          _this2.tableList.unshift({
            label: _this2.$t('payAmount'),
            prop: 'level_amount',
            desc: _this2.$t('payAmountRangeDesc')
          });

          console.log("this.tableData==", _this2.tableData);
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};